(() => {
  const navigationItems = [
    { id: "gtr-overview", label: "Overview" },
    { id: "gtr-runs", label: "How runs work" },
    { id: "gtr-current", label: "Current guitars" },
    { id: "gtr-preorder", label: "Pre-orders" },
    { id: "gtr-film", label: "Film" },
    { id: "gtr-history", label: "History" },
  ];

  function addHeroContent(hero) {
    hero.classList.add("gtr-hero");
    if (!hero.querySelector(".gtr-hero__content")) {
      hero.insertAdjacentHTML(
        "beforeend",
        `<div class="gtr-hero__content">
          <p class="gtr-eyebrow">Designed in Australia / Built in Korea</p>
          <h1>GTR</h1>
          <p class="gtr-hero__statement">Custom DNA.<br>Production precision.</p>
          <div class="gtr-hero__actions">
            <a href="#gtr-current">View current guitars</a>
            <a href="#gtr-overview">Discover GTR</a>
          </div>
        </div>`,
      );
    }

    hero.querySelectorAll(".slideshow__slide").forEach((slide) => {
      const heading = slide.querySelector(".banner__heading")?.textContent.trim();
      const image = slide.querySelector("img");
      if (image && heading && !image.alt) image.alt = `${heading} Ormsby GTR guitar`;
    });
  }

  function buildNavigation(hero) {
    const nav = document.createElement("nav");
    nav.className = "gtr-page-nav";
    nav.setAttribute("aria-label", "GTR page sections");
    nav.innerHTML = `<div class="gtr-page-nav__inner">
      ${navigationItems.map((item) => `<a href="#${item.id}">${item.label}</a>`).join("")}
    </div>`;
    hero.after(nav);
    return nav;
  }

  function structureInternationalInformation(preorder) {
    const items = preorder.querySelectorAll(".flex-item");
    const wrapper = items[1]?.firstElementChild;
    const content = wrapper?.querySelector(".enhanced-richtext");
    if (!wrapper || !content || wrapper.querySelector("details")) return;

    const details = document.createElement("details");
    details.className = "gtr-international";
    const summary = document.createElement("summary");
    summary.innerHTML = "<span>International ordering information</span><span aria-hidden=\"true\">+</span>";
    const body = document.createElement("div");
    body.className = "gtr-international__body";
    body.append(content);
    details.append(summary, body);
    wrapper.replaceChildren(details);
  }

  function observeSections(nav) {
    const links = [...nav.querySelectorAll("a")];
    const sections = navigationItems
      .map((item) => document.getElementById(item.id))
      .filter(Boolean);
    if (!sections.length || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        links.forEach((link) => {
          const isCurrent = link.hash === `#${visible.target.id}`;
          link.classList.toggle("is-active", isCurrent);
          if (isCurrent) link.setAttribute("aria-current", "location");
          else link.removeAttribute("aria-current");
        });
      },
      { rootMargin: "-20% 0px -65% 0px", threshold: [0, 0.1, 0.35] },
    );
    sections.forEach((section) => observer.observe(section));
  }

  function initializeGtrPage() {
    const main = document.querySelector(".template-page-gtr #MainContent");
    if (!main || main.dataset.gtrInitialized === "true") return;

    const hero = main.querySelector('[id*="slideshow_jRhUtX"]');
    const overviewSection = main.querySelector('[id*="ormsby_text_CWfEnx"]');
    const preorderSection = main.querySelector('[id*="ormsby_text_MBqtp6"]');
    const historySection = main.querySelector('[id*="ormsby_text_CwXM3j"]');
    const collectionSection = main.querySelector('[id*="featured_collection_aVE4re"]');
    const videoSection = main.querySelector('[id*="video_BVXQLW"]');
    if (!hero || !overviewSection || !preorderSection || !historySection) return;

    main.dataset.gtrInitialized = "true";
    addHeroContent(hero);

    const overview = overviewSection.querySelector(".ormsby-section-container");
    const preorder = preorderSection.querySelector(".ormsby-section-container");
    const history = historySection.querySelector(".ormsby-section-container");
    overview.id = "gtr-overview";
    overview.classList.add("gtr-overview");
    preorder.id = "gtr-preorder";
    preorder.classList.add("gtr-preorder");
    history.id = "gtr-history";
    history.classList.add("gtr-history");

    if (collectionSection) {
      collectionSection.id = "gtr-current";
      collectionSection.classList.add("gtr-current");
    }
    if (videoSection) {
      videoSection.id = "gtr-film";
      videoSection.classList.add("gtr-film");
    }

    structureInternationalInformation(preorder);
    const nav = buildNavigation(hero);
    observeSections(nav);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeGtrPage);
  } else {
    initializeGtrPage();
  }

  document.addEventListener("shopify:section:load", () => {
    const main = document.querySelector(".template-page-gtr #MainContent");
    if (main) delete main.dataset.gtrInitialized;
    initializeGtrPage();
  });
})();
